<div class="input-container">
  <div class="headline-description">
    @if (headLine) {
      <div class="mb-1">
        <strong>{{ headLine }} </strong>
      </div>
    }
    <div [innerHtml]="description | safeHtml" class="description"></div>
  </div>

  <div class="input-content-container" #inputcontentContainer>
    @if (!hideAbove) {
      <div
        class="input-above"
        [class.label-header]="labelHeader && !fileOrEndDateDescription"
        [class.required-end]="requiredTextEnd"
      >
        <div
          class="label-container question-mark-label"
          [class.optional]="!required"
          [class.question-mark-label]="questionMarkText"
        >
          <label
            [attr.for]="for"
            [attr.id]="id"
            [class.heading-size-5]="labelHeader"
            >{{ labelPrefix ? labelPrefix + label : label }}
          </label>
          @if (questionMarkText) {
            <div class="tooltip-target-area">
              <div
                class="tooltip-container"
                role="tooltip"
                [attr.aria-label]="questionMarkText"
                [libTooltip]="questionMarkText"
                triggers="click"
                tabindex="0"
              >
                <lib-icon
                  name="help-circle"
                  class="description-icon"
                ></lib-icon>
              </div>
            </div>
          }
        </div>
        <div class="required">
          <ng-container *transloco="let t">
            @if (required && markRequired) {
              <div class="required">
                {{ t('question_required') }}
              </div>
            }
            @if (!required && !markRequired) {
              <div class="required">
                {{ t('question_optional') }}
              </div>
            }
          </ng-container>
        </div>
      </div>
    }
    <ng-container *transloco="let t">
      <div
        [innerHtml]="fileOrEndDateDescription"
        class="fileOrEndDateDescription"
      ></div>
      <div class="position-relative input-content">
        @if (showChangeIndicator) {
          <lib-dot-indicator type="text-input" [isVisible]="true" />
        }
        <ng-content></ng-content>
      </div>

      @if (!hideBelow) {
        <div class="input-below">
          @if (helpText() && !errorText() && !warningText()) {
            <span class="help-text">{{ helpText() }}</span>
          }
          @if (errorText()) {
            <!-- Formrenderaren använder invalid-feedback för att identifiera sektioner med fel. -->
            <lib-feedback-message
              class="invalid-feedback d-block mt-0 w-auto"
              type="invalid"
              size="x-small"
            >
              <span [attr.id]="'errortext_' + id">{{ errorText() }}</span>
            </lib-feedback-message>
          }
          @if (warningText()) {
            <lib-feedback-message type="warning" size="x-small">
              <span [attr.id]="'warningtext_' + id">{{ warningText() }}</span>
            </lib-feedback-message>
          }
          @if (
            maxLength() &&
            ((inputType !== InputType.Diarienummer &&
              inputType !== InputType.Phone) ||
              inputType === undefined)
          ) {
            <div
              class="counter ms-auto"
              [class.invalid-feedback]="currentLength() > maxLength()"
            >
              @if (currentLength() <= maxLength()) {
                <span>
                  {{
                    t('question_characters_left', {
                      charactersLeft: maxLength() - currentLength(),
                    })
                  }}
                </span>
              }
              @if (currentLength() > maxLength()) {
                <span>{{
                  t('question_characters_left_negative', {
                    charactersLeft: maxLength() - currentLength(),
                  })
                }}</span>
              }
            </div>
          }
        </div>
      }
    </ng-container>
  </div>
</div>
